import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class CompanyMentorMetaModel extends FormMetaModel {
    constructor() {
        super('', ROUTE_PATH.internshipCompanyMentor, '', 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const companyName = new SmMetaInputModel(
            'companyName',
            'companyName',
            'input',
            false,
            'col-12',
            1,
            1,
            'Company Name',
            'text',
            '',
            true,
            true,
            true,
            false,
            100,
            1
        );
        const mentorName = new SmMetaInputModel(
            'mentorName',
            'mentorName',
            'input',
            true,
            'col-12 col-md-6 col-lg-4',
            1,
            1,
            'Mentor Name',
            'text',
            '[a-zA-Z][a-zA-Z ]+',
            false,
            true,
            true,
            false,
            100,
            1
        );
        const mentorCity = new SmMetaInputModel(
            'mentorCity',
            'mentorCity',
            'input',
            false,
            'col-12 col-md-6 col-lg-4',
            1,
            1,
            'City',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );


        const mentorEmail = new SmMetaInputModel(
            'mentorEmail',
            'mentorEmail',
            'input',
            true,
            'col-12 col-md-6 col-lg-4',
            1,
            1,
            'Mentor Email',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );

        const mentorMobile = new SmMetaInputModel(
            'mentorMobile',
            'mentorMobile',
            'input',
            false,
            'col-12 col-md-6 col-lg-4',
            1,
            1,
            'Mentor Mobile',
            'number',
            '',
            false,
            true,
            true,
            false,
            10,
            10
        );

        const mentorDepartment = new SmMetaInputModel(
            'mentorDepartment',
            'mentorDepartment',
            'input',
            false,
            'col-12 col-md-6 col-lg-4',
            1,
            1,
            'Department',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );

        const mentorRole = new SmMetaInputModel(
            'mentorRole',
            'mentorRole',
            'input',
            false,
            'col-12 col-md-6 col-lg-4',
            1,
            1,
            'Role',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            1
        );
        const buttons = {
            submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
            isFormControl: false
        };

        return {
            formInfo,
            companyName,
            mentorName,
            mentorEmail,
            mentorMobile,
            mentorDepartment,
            mentorRole,
            mentorCity,
            buttons
        }
    }


}


export class PostMentorModel {
    internshipCompanyId:any='';
    id:any='';
    mentorName: any = '';
    mentorEmail: any = '';
    mentorMobile: any = '';
    mentorDepartment: any = '';
    mentorRole: any = '';
    mentorCity: any = '';
}
